import { render, staticRenderFns } from "./identifyDiv.vue?vue&type=template&id=05ad86b3&scoped=true&"
import script from "./identifyDiv.vue?vue&type=script&lang=js&"
export * from "./identifyDiv.vue?vue&type=script&lang=js&"
import style0 from "./identifyDiv.vue?vue&type=style&index=0&id=05ad86b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ad86b3",
  null
  
)

export default component.exports